export default {
  video: {
    desc: '당신의 안전한 암호화폐 하드웨어 지갑',
    preOrderNow: '구매',
    watchNow: '지금 보기',
  },

  introduce: {
    title: 'KeyPal — 보안성과 사용 편의성을 모두 갖추고, 장점을 완벽하게 발휘',
    desc_1: '아무 카드나 클릭하여 더 알아보기',
    desc_2: '연결',
    desc_3: '보안',
    desc_4: '백업',
    desc_5: 'Passphrase',
    desc_6: '배터리 수명',
    desc_7: '용량',
    desc_8: '듀얼 칩',
    desc_9: '15키 배열',
    desc_10: '다양한 연결 방식 중 당신에게 맞는 방법이 있습니다',
    desc_11: 'NFC + KeyPal Card',
    desc_12: '사용',
    label_1:
      '블루투스와 QR 코드 스캔을 통해 지갑 연결 및 거래 서명을 지원합니다',
    label_1_1:
      '다양한 상황에 맞춰 연결 방식을 선택하여 하드웨어 지갑 사용을 더욱 안전하고 편리하게 합니다',
    label_2: 'KeyPal 2는 Passphrase를 지원합니다',
    label_2_1:
      '동일한 복구 구문이라도 다른 Passphrase를 사용하면 다른 지갑에 접근할 수 있어, 지갑에 한층 더 강력한 보안을 제공합니다',
    label_3: 'NFC를 지원하여 백업을 더 쉽고 빠르게 합니다',
    label_3_1:
      'KeyPal 2는 NFC를 통해 복구 구문을 KeyPal Card에 빠르게 백업할 수 있습니다',
    label_4: '배터리 용량이 더 커져 300 mAh에서 500 mAh로 업그레이드되었습니다',
    label_4_1:
      '한 번 충전으로 최대 12시간 연속 작동하여 배터리 부족 걱정을 덜어드립니다',
    label_5:
      'Le KeyPal 2 adopte une conception à double puce de qualité militaire',
    label_5_1: 'Avec une architecture MCU + SE, la sécurité commence au cœur',
    label_6: '15키 그리드로 입력과 상호작용이 더 간단해집니다',
    label_6_1:
      '콘텐츠 입력과 기능 선택을 빠르게 하여 길고 복잡한 과정을 없앱니다',
  },

  support: {
    title: '수백만 개의 암호화폐 지원',
    desc_1: '지원 목록 보기',
  },

  other: {
    title: '기타 KeyPal 제품',
    desc_1: `KeyPal Plus는 듀얼 칩 아키텍처를 적용하여 사용 편의성과 보안성을 모두 갖추었습니다. 미니멀한 디자인 스타일과 견고한 알루미늄 합금 하우징이 결합되어 내구성과 효율성을 겸비한 디지털 자산 관리 경험을 제공합니다`,
    desc_2: `KeyPal Card는 NFC 통신을 지원하며, 한 번의 터치로 니모닉 문구와 개인 키를 손쉽게 저장할 수 있습니다. 오프라인 백업과 서명 기능을 완벽하게 결합하였습니다. 신용카드 크기의 디자인으로 휴대가 간편하고 안전하여 언제 어디서나 암호화 자산을 보호합니다`,
    desc_3: `Secret Box는 304 스테인리스 소재로 제작되어 뛰어난 내열성과 내식성을 갖추고 있습니다. 문자 블록과 홈 디자인은 시드 문구 보관을 더욱 간편하고 오래 지속되게 합니다. A+B 양면 설계로 12×2, 18 또는 24단어 시드 문구 저장을 지원하여 암호화 자산에 장기적인 보안을 제공합니다`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: '클릭하여 모든 자주 묻는 질문의 답변 보기',
    question_1: '암호화 지갑이란 무엇인가요?',
    question_2: '왜 하드웨어 지갑이 필요할까요?',
    question_3: '하드웨어 지갑과 앱 지갑은 무엇이 다른가요?',
    question_4: '만약 기기를 잃어버리면 자산은 안전한가요?',
    question_5: 'KeyPal 하드웨어 지갑은 어떤 암호화폐를 지원하나요?',
  },

  discover: {
    title: '마음에 드는 KeyPal 색상을 선택하세요',
    desc_1: '발견',
  },

  instructions: {
    title: '튜토리얼 센터',
    desc: '포괄적인 데모로 KeyPal 2를 쉽게 배우고 암호 자산 관리를 간단하고 안전하게 만듭니다.',
    tabs: {
      hardware: '기기 기능',
      activation: '기기 가이드',
      connect: '지갑 연결',
      upgrade: '펌웨어 업데이트',
    },
    hardware: {
      basic: '기본 조작',
      power: '전원 켜기/끄기',
      language: '언어 선택',
      button: '버튼 조작',
      features: '기능 소개',
      security: '보안 설정',
      passphrase: '패스프레이즈 설정',
      securityOverview: '보안 설정 개요',
      verifyDevice: '기기 검증',
      asset: '자산 관리',
    },
    activation: {
      create: '시드 문구 생성',
      createByDevice: '장치에서 시드 생성',
      import: '시드 문구 불러오기',
      manualImport: '수동 가져오기',
      keypalCardImport: 'KeyPal Card 로 가져오기',
      backup: '시드 백업',
      steelBackup: '기록/금속 백업',
      keypalCardBackup: 'KeyPal Card 백업',
    },
    connect: {
      bluetooth: '블루투스로 TokenPocket 연결',
      connectAndAdd: '앱 연결 후 주소 추가',
      qrConnect: 'QR 스캔 연결',
      qrConnectTP: 'TokenPocket QR 연결',
      qrConnectMM: 'MetaMask QR 연결',
      transferReceive: '전송 및 수신',
      receiveHardware: '하드웨어로 수신',
      receiveApp: '앱으로 수신',
      transfer: '전송',
    },
    upgrade: {
      web: '웹 페이지를 통한 펌웨어 업데이트',
      bluetooth: '블루투스 업데이트',
      mobile: '모바일 업데이트',
      troubleshoot: '펌웨어 문제 해결',
      webTroubleshoot: '웹 페이지 펌웨어 업데이트 문제 해결',
      bluetoothTroubleshoot: '블루투스 펌웨어 업데이트 문제 해결',
    },
    relatedVideos: '관련 동영상',
    playing: '재생 중',
  },
};
